// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6Iagm","top":"styles_top__2tDhi"};